import Utils from "../../../../../shared/utils";

export const MAGNIFYING_GLASS_ICON = Utils.buildNewsletterLink("icons/magnifying-glass-icon.svg")